<template>
  <el-dialog :title="viewFlag ? '查看' : !dataForm.id ? '新增' : '修改'" :close-on-click-modal="false" width="70%"
             :visible.sync="viewData.visible">
    <!-- <H1 style="text-align:center">北京汽车制造厂（青岛）有限公司</H1> -->
    <div style="margin-bottom: 30px;">
      供应商：{{ decidedSupplier }}
    </div>
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="0px"
             size="mini" class="org-dialog-form">
      <el-tabs v-model="activeName">
        <el-tab-pane class="tab_style" :key="1" name="BasicInfo" :label="`基本信息`">
          <div class="des_box">
            <el-descriptions class="margin-top" :column="2" size="small" border style="margin-bottom: 15px;">
              <el-descriptions-item label="询价单编码:" :label-style="getStyle()" :content-style="getStyle2()">
                <el-form-item prop="quotationCode" style="margin-bottom: 0;">
                  {{ dataForm.rfqCode }}
                </el-form-item>
              </el-descriptions-item>
              <el-descriptions-item label="项目名称:" :label-style="getStyle()" :content-style="getStyle2()">
                <el-form-item prop="projectName" style="margin-bottom: 0;">
                  {{ dataForm.projectName }}
                </el-form-item>
              </el-descriptions-item>
              <el-descriptions-item label="任务单号:" :label-style="getStyle()" :content-style="getStyle2()">
                <el-form-item prop="projectName" style="margin-bottom: 0;">
                  {{ dataForm.taskCode }}
                </el-form-item>
              </el-descriptions-item>
              <!-- <el-descriptions-item label="技术通知编码:" :label-style="getStyle()" :content-style="getStyle2()">
                  <el-form-item prop="projectName" style="margin-bottom: 0;">
                      {{dataForm.techCode}}
                  </el-form-item>
              </el-descriptions-item> -->
              <!-- <el-col :span="8">
                      <el-form-item label="提交人" prop="projectName">
                          {{dataForm.submitor}}
                      </el-form-item>
                  </el-col> -->

              <el-descriptions-item label="询价创建时间:" :label-style="getStyle()" :content-style="getStyle2()">
                <el-form-item prop="rfqCreateTime" style="margin-bottom: 0;">
                  {{ dateFormatValue(dataForm.rfqCreateTime) }}
                </el-form-item>
              </el-descriptions-item>
              <!-- <el-descriptions-item label="询价截止时间:" :label-style="getStyle()" :content-style="getStyle2()">
                  <el-form-item prop="rfqStopTime" style="margin-bottom: 0;">
                      {{dateFormatValue(dataForm.rfqStopTime)}}
                  </el-form-item>
              </el-descriptions-item> -->
              <el-descriptions-item label="本轮报价截止时间:" :label-style="getStyle()" :content-style="getStyle2()">
                <el-form-item prop="quotationStopTime" style="margin-bottom: 0;">
                  {{ dateFormatValue(dataForm.quotationStopTime) }}
                </el-form-item>
              </el-descriptions-item>
              <!-- <el-descriptions-item label="询价状态:" :label-style="getStyle()" :content-style="getStyle2()">
                  <el-form-item prop="quotationStatus" style="margin-bottom: 0;">
                      {{dataForm.quotationStatus}}
                  </el-form-item>
              </el-descriptions-item> -->
              <el-descriptions-item label="报价状态:" :label-style="getStyle()" :content-style="getStyle2()">
                <el-form-item prop="rfqSupplierReplyStatus" style="margin-bottom: 0;">
                  {{ getRfqSupplierReplyStatus(dataForm.rfqSupplierReplyStatus) }}
                </el-form-item>
              </el-descriptions-item>
              <!-- <el-descriptions-item label="延期次数:" :label-style="getStyle()" :content-style="getStyle2()">
                  <el-form-item prop="projectName" style="margin-bottom: 0;">
                      {{dataForm.delayTimes}}
                  </el-form-item>
              </el-descriptions-item> -->
              <el-descriptions-item label="轮次:" :label-style="getStyle()" :content-style="getStyle2()">
                <el-form-item prop="projectName" style="margin-bottom: 0;">
                  {{ dataForm.times }}
                </el-form-item>
              </el-descriptions-item>
              <el-descriptions-item label="最终报价:" :label-style="getStyle()" :content-style="getStyle2()">
                <el-form-item prop="projectName" style="margin-bottom: 0;">
                  <div>
                    <el-checkbox v-model='dataForm.lastFlag' :true-label=1 :false-label=0
                                 v-if="!viewFlag && !(dataForm.rfqSupplierReplyStatus === '1')"></el-checkbox>
                    <div v-else>{{ dataForm.lastFlag ? "是" : "否" }}</div>
                  </div>
                </el-form-item>
              </el-descriptions-item>
              <el-descriptions-item label="采购工程师:" :label-style="getStyle()" :content-style="getStyle2()">
                <el-form-item prop="supplyEngineer" style="margin-bottom: 0;">
                  {{ dataForm.supplyEngineer }}
                </el-form-item>
              </el-descriptions-item>
              <!-- <el-descriptions-item label="技术负责人:" :label-style="getStyle()" :content-style="getStyle2()">
                  <el-form-item prop="techResponsor" style="margin-bottom: 0;">
                      {{dataForm.techResponsor}}
                  </el-form-item>
              </el-descriptions-item>
              <el-descriptions-item label="质量负责人:" :label-style="getStyle()" :content-style="getStyle2()">
                  <el-form-item prop="qualityResponsor" style="margin-bottom: 0;">
                      {{dataForm.qualityResponsor}}
                  </el-form-item>
              </el-descriptions-item> -->
              <el-descriptions-item label="采购组织:" :label-style="getStyle()" :content-style="getStyle2()">
                <el-form-item prop="purchaseOrgName" style="margin-bottom: 0;">
                  {{ dataForm.purchaseOrgName }}
                </el-form-item>
              </el-descriptions-item>
              <el-descriptions-item label="报价类型:" :label-style="getStyle()" :content-style="getStyle2()">
                <el-form-item prop="quotationType" style="margin-bottom: 0;">
                  {{ formattedQuotationType }}
                </el-form-item>
              </el-descriptions-item>
              <el-descriptions-item label="定点申请备注:" :label-style="getStyle()" :content-style="getStyle2()">
                <el-form-item prop="remark" style="margin-bottom: 0;">
                  {{ dataForm.remark }}
                </el-form-item>
              </el-descriptions-item>
            </el-descriptions>
          </div>
          <i  class="el-icon-warning" style="color:#E6A23C" title="请您不要忘记上传确认报价书">请您不要忘记上传确认报价书</i>
        </el-tab-pane>
        <el-tab-pane class="tab_style" :key="3" name="PurchaseInfo" :label="`采购清单`">
          <el-row :gutter="10">
            <el-col :span="24">
              <span>采购清单</span>
              <!-- <el-button v-if="dataForm.rfqStatus === QUOTATION_STATUS.QUOTAIONSTART && userInfo.typeId !== USER_TYPE.SUPPLIER" style="float:right" size=mini @click="addOrUpdateVotedSupplierHandle()">保存</el-button> -->
              <el-table :data="partList" row-key="id" size="small" :header-cell-style="{background:'#f5f5f5'}" border
                        style="width: 100%;" :default-expand-all="false">
                <el-table-column type="index" width="50" label="序号">
                </el-table-column>
                <el-table-column prop="partCode" header-align="left" align="left" label="零件编号" width="200">
                </el-table-column>
                <el-table-column prop="partName" header-align="left" align="left" label="零件名称" width="334">
                </el-table-column>
                <el-table-column
                    prop="cancelFlag"
                    header-align="left"
                    align="left"
                    label="取消标识"
                    width="150"
                    :formatter="formatCancelFlag"
                >
                </el-table-column>
                <el-table-column prop="unit" header-align="left" align="left" label="单位" width="150">
                </el-table-column>
                <el-table-column prop="oneCarCount" header-align="center" align="right" label="单车用量" width="150">
                </el-table-column>
                <el-table-column prop="supplyStatus" header-align="center" align="center" label="供货状态" width="150">
                  <template slot-scope="scope">
                    <span>{{ supplyStatusFormat(scope.row.supplyStatus) }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>&nbsp;&nbsp;
        </el-tab-pane>
        <el-tab-pane class="tab_style" name="定点申请附件" label="定点申请附件">
          <FileUpDown1 ref="FileUpDown1" :bizId="this.dataForm.technicalId" :bizType="FILE_BIZ_TYPE_TECH"></FileUpDown1>
        </el-tab-pane>
        <!--            v-if="dataForm.quotationStatus === QUOTATION_STATUS.JOINED || dataForm.quotationStatus === QUOTATION_STATUS.COMMITED" -->
        <el-tab-pane class="tab_style" :key="2" v-if="dataForm.rfqStatus !== RFQ_STATUS.BEFORE_ASK" name="QuotationInfo"
                     :label="`报价表`">
          <part-price-tab ref="partPriceTab" :vender="vender" :dataForm="dataForm"></part-price-tab>
        </el-tab-pane>
        <el-tab-pane class="tab_style" name="询价附件" label="询价附件">
          <!-- 上传下载 产看 需求文档 -->
          <el-row :gutter="10">
            <el-col :span="24">
              <FileUpDown1 ref="FileUpDown3" :bizId="dataForm.id" :bizType="FILE_BIZ_TYPE"></FileUpDown1>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane class="tab_style" name="供应商附件" label="供应商附件">
          <!-- 上传下载 产看 需求文档 -->
          <FileUpDown2 ref="FileUpDown2" :bizId="dataForm.rfqSupplierId"
                       :bizType="FILE_BIZ_TYPE_SUPPLIER"></FileUpDown2>
          <div>
            <span>需要上传的附件有：价格确认书</span>
          </div>
        </el-tab-pane>

      </el-tabs>
    </el-form>
    <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="viewData.visible = false">
            取消
        </el-button>
      <!-- 询价中 -->
        <el-tooltip
            v-if="!viewFlag && dataForm.rfqStatus === RFQ_STATUS.BEFORE_ASK && rowData.rfqSupplierReplyStatus == QUOTATION_STATUS.BEGIN"
            class="item" effect="dark" content="供应商点击参与报价" placement="top">
            <el-button size="small" type="success" plain title="供应商点击参与报价" @click="joinSubmit()">
                参与报价
            </el-button>
        </el-tooltip>
        <el-tooltip
            v-if="!viewFlag && dataForm.rfqStatus === RFQ_STATUS.BEFORE_ASK && rowData.rfqSupplierReplyStatus == QUOTATION_STATUS.BEGIN"
            class="item" effect="dark" content="供应商点击发布询价" placement="top">
            <el-button size="small" type="danger" plain @click="giveupSubmit()">
                弃权
            </el-button>
        </el-tooltip>
      <!-- 供应商保存 -->
        <el-button v-if="!viewFlag && (dataForm.rfqStatus === RFQ_STATUS.BEFORE_ASK)" size="small" type="primary" plain
                   @click="saveQuotation()">
            保存
        </el-button>
      <!-- 供应商提交报价 -->
              <el-button v-if="!viewFlag && (dataForm.rfqStatus === RFQ_STATUS.ASKING)&&dataForm.times!==1" size="small" type="success" plain
                         @click="confirmCopyLastQuotation()">
            复制上轮报价
        </el-button>
        <el-button v-if="!viewFlag && (dataForm.rfqStatus === RFQ_STATUS.ASKING)" size="small" type="success" plain
                   @click="submitQuotation()">
            提交报价
        </el-button>
      <!-- 供应商确认 -->
        <el-button v-if="!viewFlag && (dataForm.rfqStatus === RFQ_STATUS.COMMITED)" size="small" type="success" plain
                   @click="confirmQuotation()">
            确认
        </el-button>
    </span>
    <!-- 弹窗, 新增 / 修改 -->
    <!-- <addOrUpdate v-if="addOrUpdateQuotedPriceVisibe" ref="addOrUpdate" @refreshDataList="getAppartmentList"></addOrUpdate> -->
  </el-dialog>
</template>

<script>
import {
  getQuotationDetail,
  editQuotation,
  createQuotation,
  getRfqPartsByVenderId,
  copyPreviousQuotation,
  checkQuotation

} from '@/controller/quotation'
import {
  getRfqSupplierByRfqIdAndVenderId,
  getRfqPartList
} from '@/controller/rfq'
import {
  USER_TYPE,
  RFQ_STATUS,
  QUOTATION_STATUS,
  QUOTATION_STATUS_VALUE,
  SUPPLY_STATUS,
  getLabelByValue,
} from '@/utils/const'
import moment from 'moment'
import {
  copy
} from '@/utils'
// import AddOrUpdate from './quotation-part-add-or-update'
import PartPriceTab from './quotation-part-price-tab'
import FileUpDown1 from "@/views/common/file-up-down";
import FileUpDown2 from "@/views/common/file-up-down";

export default {
  components: {
    // AddOrUpdate,
    PartPriceTab,
    FileUpDown1,
    FileUpDown2,
  },
  props: {
    vender: Object,
  },
  data() {
    return {
      FILE_BIZ_TYPE: 13,
      FILE_BIZ_TYPE_SUPPLIER: 17,
      FILE_BIZ_TYPE_TECH: 10,
      // addOrUpdateQuotedPriceVisibe: false,
      rowData: null,
      viewFlag: false,
      tableData: [],
      activeName: 'BasicInfo',
      RFQ_STATUS: RFQ_STATUS,
      QUOTATION_STATUS: QUOTATION_STATUS,
      viewData: {
        visible: false,
        width: ''
      },
      dataList: [],
      supplierList: [],
      partList: [],
      rfqSupplierReplyStatus: '',
      userInfo: '',
      USER_TYPE: USER_TYPE,
      decidedSupplier: '',
      dataForm: {
        technicalId: '',
        rfqSupplierReplyStatus: '',
        id: 0,
        name: '',
        code: '',
        parentId: '',
        parentName: '',
        mwskz: '',
        parentNodePath: '',
        tenantId: '',
        tenantName: '',
        projectId: '',
        projectName: '',
        projectCode: '',
        technicalCode: '',
        taskCode: '',
        rfqCode: '',
        feeCode: '',
        submitor: '',
        rfqCreateTime: '',
        rfqStopTime: '',
        quotationStopTime: '',
        rfqStatus: '',
        quotationStatus: '',
        delayTimes: 0,
        times: 0,
        supplyResponsor: '',
        supplyEngineer:'',
        techResponsor: '',
        qualityResponsor: '',
        carType: '',
        deleteFlag: 0,
        lastFlag: 0,
        rfqSupplierId: '',
        purchaseOrgName: '',
        quotationType:'',
        remark: ''
      },
      ip:'',
      dataRule: {},
      quotationTypeDict: {
        '1': '简单报价',
        '2': '汇总报价',
        '3': '详细报价'
      },
      cancelFlagDict: {
        '0': '否',
        '1': '是'
      }
    }
  },
  mounted() {
    this.getClientIP()
  },
  computed: {
    formattedQuotationType() {
      return this.quotationTypeDict[this.dataForm.quotationType] || '未知类型'
    }
  },
  methods: {
    init(data, id, viewFlag) {
      console.log('跳转过来的传递参数', data)
      this.dataForm.technicalId = data.technicalId
      this.dataForm.rfqSupplierId = data.rfqSupplierId
      this.dataForm.rfqSupplierReplyStatus = data.rfqSupplierReplyStatus
      this.activeName = "BasicInfo"
      this.rowData = Object.assign({}, data);
      this.viewFlag = viewFlag
      if (!this.dataForm.quotationStatus) this.dataForm.quotationStatus = 1
      this.userInfo = this.$store.state.user.userInfo
      // this.dataForm = data ? data : this.data
      // this.dataForm = copy(this.dataForm)
      this.dataForm.id = this.rowData.id || 0
      this.dataForm.purchaseOrgName = data.purchaseOrgName
      this.dataForm.quotationType=data.quotationType
      this.dataForm.supplyEngineer=data.supplyEngineer
      this.viewData.visible = true
    console.log('赋值后dataForm参数',this.dataForm)

      this.$nextTick(() => {
        // this.$refs['dataForm'].resetFields()
        // this.dataForm.tenantName = sessionStorage.getItem('tenantName')
        if (this.dataForm && this.dataForm.id) {
          // getQuotationDetail({}, this.dataForm.id).then(data => {
          //     console.log(data)
          //     if (data && data.code === '00') {
          //         this.dataForm = data.body
          //     }
          // })
          getRfqSupplierByRfqIdAndVenderId({
            rfqId: this.dataForm.id,
            rfqVenderId: this.vender.id
          }).then(data => {
            if (data && data.code === '00') {
              console.log("查询返回的RfqSupplier", data.body.id)
              this.dataForm.rfqSupplierId = data.body.id

              this.dataForm = this.rowData;
              console.log("dataform中的rfqSupplierId", this.dataForm.rfqSupplierId)
              //初始化上传附件
              this.$refs.FileUpDown1.init('view');
              this.$refs.FileUpDown3.init('view');
              if (this.viewFlag) {
                this.$refs.FileUpDown2.init('view');
              } else {
                this.$refs.FileUpDown2.init('edit');
              }
              // 获取供应商状态
              // this.getSupplierByVenderId()
              this.decidedSupplier = this.vender.venderName;
              this.$refs.partPriceTab.getAppartmentList(this.viewFlag, this.dataForm.times, this.dataForm.lastFlag)
              this.getPartList()
            }
          })
        }
      })
    },
    dateFormat: function (row, column) {
      var date = row[column.property]
      if (!date) {
        return ''
      }
      return moment(date).format("YYYY-MM-DD前")
    },
    dateFormatValue: function (value) {
      if (!value) {
        return ''
      }
      return moment(value).format("YYYY-MM-DD")
    },
    // 查所有零件
    getPartList() {
      getRfqPartList({
        pageNo: this.pageIndex,
        pageSize: this.pageSize,
        rfqId: this.dataForm.id,
      }).then((data) => {
        if (data && data.code === "00") {
          if (data.body) {
            debugger
            this.partList = data.body
            this.totalPage = data.body.total
          } else {
            this.partList = []
            this.totalPage = 0
          }
        } else {
          this.partList = []
          this.totalPage = 0
        }
      })
    },
    // 查所有供应商表
    // getCurrentSupplierStatus() {
    //     getRfqSupplierByVenderId({
    //         userId: this.userInfo.id,
    //     }).then((data) => {
    //         if (data && data.code === "00") {
    //             this.rfqSupplierReplyStatus = data.body.rfqSupplierReplyStatus;
    //         } else {
    //             this.supplierList = [];
    //         }
    //     });
    // },
    // 供应商采购员保存报价
    saveQuotation() {
      // TODO: 每个供应商填写报价六张表
      // 附件文件上传
      this.dataFormSubmit('保存报价成功')
    },
    joinSubmit() {
      // 更新供应商报价状态
      this.dataForm.quotationStatus = QUOTATION_STATUS.JOINED
      this.rowData.rfqSupplierReplyStatus = QUOTATION_STATUS.JOINED;
      // 更新供应商列表里的参与
      this.dataFormSubmit('参与成功')
    },
    giveupSubmit() {
      // 更新供应商报价状态
      this.dataForm.quotationStatus = QUOTATION_STATUS.REJECT
      this.rowData.rfqSupplierReplyStatus = QUOTATION_STATUS.REJECT;
      // 更新供应商列表里的状态放弃
      this.dataFormSubmit('已弃权')
    },
    // 供应商提交报价
    submitQuotation() {
      // 整个都是报价中吗？
      // TODO: 每个供应商填写报价六张表
      // 附件文件上传
      // 供应商上传价格确认书
      // 更新供应商报价状态
      //   this.$message({
      //     message: '请您不要忘记上传确认报价书',
      //     type: 'success'
      //   });
      // 校验是否上传了价格确认书
      const isAttachmentExist = this.checkPriceConfirmationAttachment();
      if (!isAttachmentExist) {
        this.$message.error(`请上传第${this.dataForm.times}轮次价格确认书`);
        return;
      }

      for (let i = 0; i < this.$refs.partPriceTab.partList.length; i++) {
        console.log("取消标识",this.$refs.partPriceTab.partList[i].cancelFlag);
        if (this.$refs.partPriceTab.partList[i].cancelFlag===0&&!this.$refs.partPriceTab.partList[i].id) {
          this.$message.error("您还有零件未报价，不能提交报价")
          return;
        }
      }
      let params = copy(this.dataForm)
      checkQuotation(params).then(data => {
        if (data && data.code != '00') {
          this.$message.error("您还有零件未报价，不能提交报价")
          return;
        }else {
          this.dataForm.quotationStatus = QUOTATION_STATUS.COMMITED
          this.dataFormSubmit('提交报价成功')
        }
      })
    },

    confirmQuotation() {
      this.dataForm.quotationStatus = QUOTATION_STATUS.CONFIRM
      this.dataFormSubmit('确认报价成功')
    },
    // 表单提交
    dataFormSubmit(msg) {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          let params = copy(this.dataForm)
          if (this.dataForm.id) {
            params['venderId'] = this.rowData.venderId;
            params['ip'] =this.ip;
            editQuotation(params).then(data => {
              if (data && data.code === '00') {
                this.$message({
                  message: msg,
                  type: 'success',
                  onClose: () => {
                    this.viewData.visible = false
                    this.$emit('refreshDataList')
                  }
                })
              } else {
                this.$message.error(data.msg)
              }
            })
          } else {
            createQuotation(params).then(data => {
              if (data && data.code === '00') {
                this.$message({
                  message: msg,
                  type: 'success',
                  onClose: () => {
                    // this.viewData.visible = false
                    this.$emit('refreshDataList')
                  }
                })
              } else {
                this.$message.error(data.msg)
              }
            })
          }
        }
      })
    },
    // 检查价格确认书附件是否存在
    checkPriceConfirmationAttachment() {
      // 从附件组件获取附件列表
      const attachmentList = this.$refs.FileUpDown2.getFileList();
      console.log("附件表信息", attachmentList);
      if (!attachmentList || attachmentList.length === 0) {
        return false;
      }

      // 构建目标文件名：第XX轮次价格确认书
      const targetFileName = `第${this.dataForm.times}轮次价格确认书`;

      // 检查附件列表中是否存在目标文件
      return attachmentList.some(attachment => {
        // 考虑可能有不同文件扩展名，只检查文件名部分
        const fileName = attachment.originalName.split('.')[0];
        return fileName.includes(targetFileName);
      });
    },
    supplyStatusFormat: function (value) {
      if (!value) {
        return "";
      }
      return getLabelByValue(SUPPLY_STATUS, value);
    },
    getRfqSupplierReplyStatus: function (value) {
      if (!value) {
        return "";
      }
      return getLabelByValue(QUOTATION_STATUS_VALUE, value);
    },
    // // 新增 / 修改 报价
    // addOrUpdateHandle(row) {
    //     this.addOrUpdateQuotedPriceVisibe = true;
    //     row.rfqId = this.dataForm.id
    //     this.$nextTick(() => {
    //         this.$refs.addOrUpdate.init(row, this.vender);
    //     });
    // },
    // showHandle(row) {
    //     this.addOrUpdateQuotedPriceVisibe = true;
    //     row.rfqId = this.dataForm.id
    //     this.$nextTick(() => {
    //         this.$refs.addOrUpdate.init(row, this.vender, 'view');
    //     });
    // },
    getStyle() {
      return 'width: 110px; text-align: right'
    },
    getStyle2() {
      // return 'width: 455.5px;'
    },
    formatCancelFlag(row, column, cellValue) {
      return this.cancelFlagDict[cellValue] || '未知';
    },
    // 确认复制上轮报价
    confirmCopyLastQuotation() {
      this.$confirm(
          '将复制上一轮报价数据，并覆盖本轮报价中已编辑的数据，是否确认操作？',
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
      ).then(() => {
        // 用户点击确定后执行复制逻辑
        this.copyQuotation(); // 调用原有的提交函数
      }).catch(() => {
        // 用户点击取消后的操作（可选）
        this.$message.info('已取消操作');
      });
    },
    // 原有的提交函数（保持不变）
   copyQuotation() {
     let param=copy(this.dataForm);
     copyPreviousQuotation(param).then(data => {
       if (data && data.code === '00') {
         this.$message({
           message: "操作成功",
           type: 'success',
         })
       } else {
         this.$message.error(data.msg)
       }
     })
    },
    getClientIP() {
      // 调用公共IP查询服务
      fetch('https://api64.ipify.org?format=json')
          .then(response => response.json())
          .then(data => {
            console.log('客户端真实IP:', data.ip);
            this.ip = data.ip;
          })
          .catch(error => {
            console.error('获取IP失败:', error);
          });
    }
  }
}
</script>

<style lang="scss" scoped>
.el-dialog__body {
  .org-dialog-form {
    width: 100%;
  }
}

.linetext {
  white-space: pre-line;
}

.button-danger {
  color: #F56C6C
}

.mb15 {
  margin-bottom: 15px;
}

.tab_style {
  min-height: 35vh;
}
</style>
